const esp = {
  next: "Siguiente",
  prev: "Anterior",
  menu:{
    home: "Inicio",
    about: "Acerca de mi",
    contact: "Contacto"
  },
  home: {
    title:
      "Desarrollador web, modelador 3D, artista de pixel art & desarrollador de videojuegos",
    description:
      "Hola me llamo Raúl, me considero a mi mismo un polímata, con un fuerte entusiasmo por aprender acerca de nuevas areas",
    recent: { title: "ENTRADAS RECIENTES" },
    areas: {
      title: "ALGUNAS DE MIS AREAS DE TRABAJO",
      tools_t: "Herramientas",
      projects_t: "Proyectos",
      more: "Ver más",
      web: {
        title: "Desarrollo Web",
        tools:
          "<strong>NodeJS, React, Firebase, Git, Visual studio code</strong>, PHP, Wordpress, MySQL, MongoDB",
        projects: "Este sitio, Konfort eshop, ...",
      },
      model3d: {
        title: "Modelado 3D",
        tools: "<strong>Blender</strong>, Maya, Mudbox, MagicaVoxel.",
        projects: "Peter Sloth, Sendero Pacifico (Animales) ...",
      },
      pixel: {
        title: "Pixel Art",
        tools: "<strong>Aseprite</strong>, Gimp, Krita, Inkscape, MagicaVoxel.",
        projects: "Mandragora (Agartota), Cervates, Octobit 2020, ...",
      },
      game: {
        title: "Desarrollo de Juegos",
        tools:
          "<strong>Unity 3D, Git, Visual studio code</strong>, PlayCanvas(WIP)",
        projects:
          "Sendero Pacifico (AR), Agartota Domain - Beta (collab Héctor Salas), A-tempus (VN WIP), Color Witch (WIP), ...",
      },
    },
    contact: {
      title: "¿Tienes interés en trabajar conmigo?",
      talk: "Háblame al respecto",
    },
  },
  blog: {
    search: "Buscar",
  },
  about: {
    title: "Acerca de mí",
    birthday: "Fecha de nacimiento",
    span: "Español",
    eng: "Inglés",
    span_lvl: "Nativo",
    eng_lvl: " Intermedio Avanzado (B2)",
    description: "Soy un polimata, autodidacta, responsable y creativo, con mucho gusto por aprender sobre diferentes áreas. Cuento con un buen conjunto de habilidades en el área de desarrollo web, también tengo conocimientos en diseño digital, edición de imágenes, edición de video, modelado 3D y animación 3D. Cuanto más conocimientos adquiero, más cómodo me siento.",
    education: "Educación",
    ucr: "Universidad de Costa Rica",
    bach_itm: "Bachillerato en Informática y Tecnologías Multimedia (marzo 2014-mayo 2018)",
    lic_itm: "Licenciatura en Informática y Tecnologías Multimedia (enero 2018-febrero 2021)",
    work_exp: "Experiencia Laboral",
    leaf_job: "Desarrollador full-stack (agosto 2017-diciembre 2018) Costa Rica, San José, Mata Redonda.",
    skills: "Habilidades",
    programming_langs: "Lenguajes de programación",
    for_unity: "para Unity3D",
    tecnologies: "Tecnologías / Frameworks / Herramientas",
    db: "Bases de datos",
    others: "Otros",
    agile: "Metodologías Ágiles",
    ux: "Diseño UX",
    model3d: "Modelado 3D",
    design: "Diseño Gráfico",
    image_ed: "Edición de Imagenes",
    video_ed: "Edición de Video",
    animate3d: "Animación 3D",
    soft_skills: "Habilidades Blandas",
    soft_desc: "Siempre en búsqueda de nuevo conocimiento, autodidacta, entusiasta ante nuevas tareas e implementación de nuevas herramientas, bueno trabajando trabajo en equipo, amigable, bueno siguiendo instrucciones y en pos de aportar nuevas soluciones de ser requerido.",
    hobbies: "Aficiones",
    videogames: "Video juegos",
    read: "Lectura",
    write: "Escritura",
    agriculture: "Agricultura",
    dialogue: "Dialogar"
  },
  contact: {
    title: "Contacto",
  },
};

export default esp;
